import React from 'react';
import HorseAccordian from './HorseAccordian';
var ListCard = function (_a) {
    var headingToDisplay = _a.headingToDisplay, idToDisplay = _a.idToDisplay, currentStatus = _a.currentStatus, horseData = _a.horseData, handleClick = _a.handleClick, _b = _a.displayChip, displayChip = _b === void 0 ? false : _b, _c = _a.isButtonDisabled, isButtonDisabled = _c === void 0 ? false : _c;
    var statusMapper = {
        start: {
            text: 'Started',
            buttonStyles: 'text-[#4886FF] border-[#4886FF] hover:bg-[#4886FF] hover:text-white'
        },
        pending: {
            text: 'Under Review',
            buttonStyles: 'text-[#ffde85] border-[#ffde85] hover:bg-[#ffde85] hover:text-white'
        },
        complete: {
            text: 'Quote Created',
            buttonStyles: 'text-primary border-primary hover:bg-primary hover:text-white'
        },
        bound: {
            text: 'Active',
            buttonStyles: 'text-[#42D58E] border-[#42D58E] hover:bg-[#42D58E] hover:text-white'
        },
        active: {
            text: 'Active',
            buttonStyles: 'text-[#42D58E] border-[#42D58E] hover:bg-[#42D58E] hover:text-white'
        },
        rejected: {
            text: 'Declined',
            buttonStyles: 'text-[#FD515E] border-[#FD515E] hover:bg-[#FD515E] hover:text-white'
        },
        cancelled: {
            text: 'Cancelled',
            buttonStyles: 'text-[#FF6B6B] border-[#FF6B6B] hover:bg-[#FF6B6B] hover:text-white'
        },
        expired: {
            text: 'Expired',
            buttonStyles: 'text-[#A0AEC0] border-[#A0AEC0] hover:bg-[#A0AEC0] hover:text-white'
        }
    };
    var fallbackButtonData = {
        text: currentStatus,
        buttonStyles: 'text-[#A0AEC0] border-[#A0AEC0] hover:bg-[#A0AEC0] hover:text-white'
    };
    var buttonData = statusMapper[currentStatus] || fallbackButtonData;
    var defaultButtonStyles = 'text-primary border-primary enabled:hover:bg-primary enabled:hover:text-white';
    return (React.createElement("div", null,
        React.createElement("li", { className: "flex items-center justify-between px-6 py-4 gap-1" },
            React.createElement("div", { className: "flex flex-col items-start flex-grow min-w-0" },
                React.createElement("h4", { className: "text-lg text-gray-600 font-semibold" }, headingToDisplay),
                React.createElement("h3", { title: idToDisplay, className: "text-lg text-left font-bold text-[#1F2751] truncate w-full" }, idToDisplay)),
            React.createElement("div", { className: "flex gap-2 items-center whitespace-nowrap shrink-0" },
                displayChip && (React.createElement("p", { className: "flex items-center text-sm font-semibold" },
                    React.createElement("span", { className: "h-2 w-2 bg-[#FD515E] rounded-full mr-2" }),
                    "Click to restart")),
                React.createElement("button", { className: "px-4 py-2 rounded-lg border border-solid transition-all duration-300 ease-in-out ".concat(defaultButtonStyles, " font-bold cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 min-w-24"), onClick: function () { return handleClick(); }, disabled: isButtonDisabled }, buttonData.text))),
        React.createElement(HorseAccordian, { data: horseData })));
};
export default ListCard;
